import React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../../app/context'
import { Entity } from '../../app/entity'
import Navigator from '../../app/navigator'
import { Operation } from '../../domain/Operation'
import { ApplicationState } from '../../redux/ApplicationState'
import { OperationsGraphEntity } from '../../redux/operations/OperationsState'
import ActualGraph from '../graph/tooltip-graph'
import Snapshot from '../snapshot/snapshotModel'
import TimeRangeLabel from '../timeRangeLabel'

interface StateProps {
    navigator: Navigator
    tidewaysContext: TidewaysContext
}

interface OwnProps {
    operation: Operation
}

type Props = StateProps & OwnProps & Entity<OperationsGraphEntity | null>

class Graph extends React.Component<Props> {
    public static defaultProps = {
        loading: false,
        data: null,
    }
    private chart: React.RefObject<HTMLDivElement>

    public constructor(props) {
        super(props)

        this.chart = React.createRef<HTMLDivElement>()
    }

    public componentDidMount() {
        if (!this.chart.current) {
            return
        }

        jQuery(this.chart.current).on('eventClicked', (event, group) => {
            this.props.navigator.push({ event: group[0].id }, 'XhprofProfilerBundle.Event.show')
        })

        jQuery(this.chart.current).on('rangeSelected', (event, dataSet, nextDataSet) => {
            const snapshot = Snapshot.fromDataSets(dataSet, nextDataSet)

            this.props.navigator.push(
                { ...snapshot.toParameters(), operation: this.props.operation.id },
                'XhprofProfilerBundle.OperationSnapshot.show',
            )
        })

        jQuery(this.chart.current).on('rangeDelesect', event => {
            this.props.navigator.push(
                { date: null, end: null, operation: this.props.operation.id },
                'XhprofProfilerBundle.Transaction.show',
            )
        })
    }

    public render() {
        return (
            <div className="jquery-tooltip-reference" ref={this.chart}>
                <div className={this.props.operation.serviceType === 'external' ? 'external-monitoring-graph' : undefined}>
                    <ActualGraph {...this.props}>
                        <h3 className="box-title">
                            Response Times for <TimeRangeLabel />
                        </h3>
                    </ActualGraph>
                </div>
            </div>
        )
    }
}

export default connect<StateProps & Entity<OperationsGraphEntity | null>, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    const graph = globalState.operations.graph[props.operation.id] || new Entity()

    return {
        navigator: new Navigator(globalState.tidewaysContext.route),
        tidewaysContext: globalState.tidewaysContext,
        ...graph,
    }
})(Graph)
